import { render, staticRenderFns } from "./SupportingFiles.vue?vue&type=template&id=2713c593&"
import script from "./SupportingFiles.vue?vue&type=script&lang=ts&"
export * from "./SupportingFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports